<h2>Printwerk nodig</h2>
<div class="upper-space">
  <div class="indent">
    <div class="d-flex">
      <checkbox
        [text]="'Printwerk nodig'"
        [checked]="needPrintworkChecked"
        (answer)="needPrintworkChecked = $event"
      ></checkbox>
      <mat-spinner
        *ngIf="resettingPrintwork"
        class="align-registration-with-textbox"
        color="primary"
        diameter="24"
      ></mat-spinner>
      <div
        *ngIf="
          !resettingPrintwork &&
          printworkAndAtelierInfo?.mostRecentPrintRelatedRegisteredAction !=
            null
        "
        class="left-space align-registration-with-textbox strong"
      >
        <ng-container
          *ngIf="
            !printworkAndAtelierInfo.printWorkFinished;
            else fullPrintRegistration
          "
        >
          (laatste keer geprint:
          {{
            printworkAndAtelierInfo.mostRecentPrintRelatedRegisteredAction.date
              | formatDate : '__/__' : 'dd/MM'
          }})
        </ng-container>
        <ng-template #fullPrintRegistration>
          <span
            >{{
              printworkAndAtelierInfo.mostRecentPrintRelatedRegisteredAction
                .user?.firstName
                | personName
                  : printworkAndAtelierInfo
                      .mostRecentPrintRelatedRegisteredAction.user?.lastName
            }}
          </span>
          <span
            >{{
              printworkAndAtelierInfo.mostRecentPrintRelatedRegisteredAction
                .date | formatDate : '__/__' : 'dd/MM'
            }}
          </span>
          <span
            class="clickable secondary-color left-space"
            (click)="resetPrintwork()"
            >X reset</span
          >
        </ng-template>
      </div>
    </div>
  </div>
  <ng-container *ngIf="needPrintworkChecked">
    <div *ngIf="printWorkChecked" class="upper-space">
      <div>
        <label>Voorraadbord</label>
        <div class="indent">
          <checkbox
            [text]="productDescription"
            [checked]="printWorkChecked.ipBoardChecked"
            (answer)="printWorkChecked.ipBoardChecked = $event"
          ></checkbox>
        </div>
      </div>
      <div>
        <label>Ontwerp</label>
        <div class="indent">
          <checkbox
            [text]="'Titel'"
            [checked]="printWorkChecked.titleChecked"
            (answer)="printWorkChecked.titleChecked = $event"
          ></checkbox>
          <checkbox
            [text]="'Telefoon'"
            [checked]="printWorkChecked.phoneNumberChecked"
            (answer)="printWorkChecked.phoneNumberChecked = $event"
          ></checkbox>
          <checkbox
            [text]="'Tekst'"
            [checked]="printWorkChecked.textChecked"
            (answer)="printWorkChecked.textChecked = $event"
          ></checkbox>
          <checkbox
            [text]="'Extra onder- of bovenborden'"
            [checked]="printWorkChecked.extraBoardChecked"
            (answer)="printWorkChecked.extraBoardChecked = $event"
          ></checkbox>
          <checkbox
            *ngIf="showStickerCheckbox"
            [text]="'Ineens met sticker'"
            [checked]="printWorkChecked.stickerChecked"
            (answer)="printWorkChecked.stickerChecked = $event"
          ></checkbox>
        </div>
      </div>
      <div>
        <label>Plaatsing</label>
        <div class="indent">
          <checkbox
            [text]="'Pijltjes'"
            [checked]="printWorkChecked.arrowsChecked"
            (answer)="printWorkChecked.arrowsChecked = $event"
          ></checkbox>
          <checkbox
            [text]="'2de bord'"
            [checked]="printWorkChecked.secondBoardChecked"
            (answer)="printWorkChecked.secondBoardChecked = $event"
          ></checkbox>
          <checkbox
            [text]="'Extra bestelling'"
            [checked]="printWorkChecked.otherOrderChecked"
            (answer)="printWorkChecked.otherOrderChecked = $event"
          ></checkbox>
        </div>
      </div>
    </div>
    <div class="upper-space indent">
      <label class="regular">Extra print info</label>
      <textarea-input
        [placeholder]="'Extra info printwerk'"
        [initContent]="needsPrintworkDescription"
        [client]="true"
        (answer)="needsPrintworkDescriptionChanged($event)"
      >
      </textarea-input>
    </div>
  </ng-container>
  <div>
    <label>Atelier</label>
    <div class="indent">
      <div class="d-flex">
        <checkbox
          [text]="'Opdracht klaarmaken door atelier'"
          [checked]="printWorkChecked.atelierChecked"
          (answer)="printWorkChecked.atelierChecked = $event"
        ></checkbox>
        <mat-spinner
          *ngIf="resettingAtelier"
          class="align-registration-with-textbox"
          color="primary"
          diameter="24"
        ></mat-spinner>
        <div
          *ngIf="
            !resettingAtelier &&
            (printworkAndAtelierInfo?.lastAtelierOperationAt != null ||
              printworkAndAtelierInfo?.atelierEmployeeUser != null)
          "
          class="left-space align-registration-with-textbox d-flex strong"
        >
          <div
            *ngIf="printworkAndAtelierInfo.atelierEmployeeUser != null"
            class="d-flex"
          >
            <span>{{
              printworkAndAtelierInfo.atelierEmployeeUser.firstName
                | personName
                  : printworkAndAtelierInfo.atelierEmployeeUser.lastName
            }}</span>
            <span
              class="clickable impersonate-icon"
              [matTooltip]="'Nabootsen'"
              (click)="impersonateAtelierEmployee()"
              ><mat-icon>group</mat-icon></span
            >
          </div>
          <ng-container
            *ngIf="
              !printworkAndAtelierInfo.atelierFinished;
              else fullAtelierRegistration
            "
          >
            <div
              *ngIf="printworkAndAtelierInfo.lastAtelierOperationAt != null"
              class="left-space"
            >
              (laatste bewerking in atelier:
              {{
                printworkAndAtelierInfo.lastAtelierOperationAt
                  | formatDate : '__/__' : 'dd/MM'
              }})
            </div>
          </ng-container>
          <ng-template #fullAtelierRegistration>
            <div class="left-space">
              <span
                >{{
                  printworkAndAtelierInfo.lastAtelierOperationAt
                    | formatDate : '__/__' : 'dd/MM'
                }}
              </span>
              <span
                class="clickable secondary-color left-space"
                (click)="resetAtelier()"
                >X reset</span
              >
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="printWorkChecked?.atelierChecked" class="upper-space indent">
    <label class="regular">Extra info voor atelier</label>
    <textarea-input
      [placeholder]="'Extra info voor atelier'"
      [initContent]="needsAtelierDescription"
      (answer)="needsAtelierDescriptionChanged($event)"
    >
    </textarea-input>
  </div>
</div>
<div class="button-container">
  <ng-container *ngIf="!submitting">
    <button class="btn close-button" (click)="closeDialog()">Sluiten</button>
    <button
      mat-button
      class="summary-dialog-button confirm-button"
      (click)="confirmNeedsPrintwork()"
    >
      Opslaan
    </button>
  </ng-container>
  <ng-container *ngIf="submitting">
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </ng-container>
</div>
